// Kleines Ereignis, damit die Kopfzeile den Zähler ungelesener
// Benachrichtigungen nach dem Lesen sofort aktualisiert.
const EVENT = 'unread-notifications-changed';
export const notifyUnreadChanged = () => window.dispatchEvent(new Event(EVENT));
export const onUnreadChanged = (cb: () => void) => {
  window.addEventListener(EVENT, cb);
  return () => window.removeEventListener(EVENT, cb);
};
